import { ComponentProps } from "react";
import TemplateCardNavigationView from "./TemplateCardNavigationView";

export default TemplateCardNavigationView;
export type TemplateCardNavigationViewProps = ComponentProps<
  typeof TemplateCardNavigationView
>;
